import cx from 'classnames'
import dayjs from 'dayjs'
import durationPlugin from 'dayjs/plugin/duration'
import Styles from './VideoDuration.module.scss'
import { Play3 } from 'blaze-ui/icons'

dayjs.extend(durationPlugin)

interface Props {
  duration: number
  iconSize?: number
  containerClassName?: string
  textClassName?: string
  position?: 'right' | 'left'
  showIcon?: boolean
}

export const durationLabel = (duration: number) => {
  const dayjsDuration = dayjs.duration(duration ?? 0, 'seconds')
  const seconds = dayjsDuration.seconds()
  const hours = dayjsDuration.hours()
  const minutes = dayjsDuration.minutes()
  const durationLabel = `${hours ? `${hours}:` : ''}${minutes < 10 ? '0' + minutes : minutes}:${
    seconds < 10 ? '0' + seconds : seconds
  }`

  return durationLabel
}

export const VideoDuration = ({
  duration,
  iconSize = 8,
  showIcon = true,
  containerClassName = '',
  textClassName = '',
  position = 'right',
}: Props) => {
  return (
    <div className={cx(Styles.duration, containerClassName, [Styles[position]])} data-testid="video-duration">
      {showIcon && <Play3 size={iconSize} />}
      <span className={textClassName}>{durationLabel(duration)}</span>
    </div>
  )
}
